module.exports = __webpack_public_path__ + "img/logo-full-for-brightBG.bb3fe036.svg";